import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { CommReviewReportTable } from "./CommReviewReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { CommReviewReportFilter } from "./CommReviewReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const CommReviewReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="exchCommissionReview" />}
              action={<CommReviewReportActions />}
            />
            <Divider />
            <CardContent>
              <CommReviewReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const CommReviewReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <CommReviewReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default CommReviewReport;
